<template>
    <div class="notes-section">
        <skeleton-loader v-if="loading" type="rows" :count="3" />
        <template v-else>
            <div v-if="notes.length" class="notes-list">
                <div v-for="note in currentNotes" :key="note.id" class="note-item" v-ripple @click="editNote(note)">
                    <span class="note-text">{{ note.title }}</span>
                    <v-icon v-if="note.pinned" size="14" color="txtMuted">mdi-pin</v-icon>
                </div>
            </div>
            <div v-else class="notes-empty">{{ $t('common.no_notes') }}</div>

            <kimsa-pagination v-if="pageCount > 1" class="notes-pagination" @page="page = $event - 1"
                :pageCount="pageCount" :total-visible="isMobile ? 5 : 7" :value="page + 1" />

            <add-text-button v-if="!headerAdd" :label="`${$t('common.add')} ${$t('common.note')}`"
                @click="showAddNote" />
        </template>

        <notes-student-dialog ref="notes" @saved="loadNotes" :student-id="studentId" />
    </div>
</template>

<script>
import NotesStudentDialog from './NotesStudentDialog.vue';
import { db } from "@/utils/Firebase";
import KimsaPagination from '../common/KimsaPagination.vue';
import SkeletonLoader from '../common/SkeletonLoader.vue';
import AddTextButton from '../common/AddTextButton.vue';
export default {
    components: { NotesStudentDialog, KimsaPagination, SkeletonLoader, AddTextButton },
    name: "NotesStudentSection",
    props: {
        studentId: {
            type: String,
            default: null,
        },
        headerAdd: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            notes: [],
            page: 0,
            limit: 5,
        }
    },
    computed: {
        coachId(vm = this) {
            return vm.currentUser?.uid || null
        },
        currentNotes(vm = this) {
            let currentPage = (vm.page * vm.limit)
            return vm.notes.slice(currentPage, currentPage + vm.limit)
        },
        pageCount(vm = this) {
            return Math.ceil(vm.notes.length / vm.limit)
        }
    },
    mounted() {
        const vm = this;
        vm.loadNotes()
    },
    methods: {
        async loadNotes() {
            const vm = this;
            await vm.withLoading(async () => {
                const notesRef = await db.collection('studentNotes')
                    .where('coachId', '==', vm.coachId)
                    .where('studentId', '==', vm.studentId)
                    .orderBy('pinned', 'desc')
                    .orderBy('createdAt', 'desc')
                    .get()

                vm.notes = notesRef.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }))
            })
        },
        showAddNote() {
            this.$refs.notes.show()
        },
        editNote(note) {
            this.$refs.notes.setDefaultsProfileSection(note)
        }
    }
}
</script>

<style scoped>
.notes-section {
    display: flex;
    flex-direction: column;
}

.notes-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.note-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    padding: 11px 14px;
    cursor: pointer;
    transition: background 0.15s;
}

.note-item:hover {
    background: var(--v-outline-base);
}

.note-text {
    font-size: 13px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    line-height: 1.5;
}

.notes-empty {
    font-size: 13px;
    color: var(--v-txtMuted-base);
    padding: 4px 0;
}

.notes-pagination {
    margin-top: 8px;
}
</style>
